module.exports = __webpack_public_path__ + "img/newgame.3a3e5903.png";